module.exports = __webpack_public_path__ + "static/media/FB.ff200282.jpg";